import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	componentWrapper: {
		display: 'flex',
		height: '100%',
		justifyContent: 'center'
	},
	disabledUserWrapper: {
		backgroundColor: '#fcf2f2',
		display: 'flex',
		width: '100%',
		height: '200px',
		flexDirection: 'column',
		justifyContent: 'center',
		alignSelf: 'center'
	},
	title: {
		color: '#B94A48',
		fontSize: '24px',
		alignSelf: 'center'
	},
	text: {
		color: theme.palette.common.black,
		fontSize: theme.spacing(2),
		maxWidth: '90vw',
		alignSelf: 'center',
		paddingBottom: theme.spacing(1)
	},
	button: {
		alignSelf: 'center',
		fontSize: theme.spacing(2),
		color: theme.palette.common.white,
		backgroundColor: theme.palette.primary.main,
		'&:hover': {
			backgroundColor: '#213ab9',
			color: theme.palette.common.white
		}
	}
}));

export default useStyles;
